import { mapState } from 'vuex';
import customColorMixin from '@/mixins/customColor';
import stateHistoryFetchMixin from '@/mixins/stateHistoryFetch';
import { get, debounce } from 'lodash';
export default {
  name: 'CoreVirtualDevicePacketHistoryViewer',
  mixins: [customColorMixin, stateHistoryFetchMixin],
  props: {
    height: {
      type: Number,
      default: 300,
      required: false
    },
    queryStartDate: {
      type: String,
      required: false,
      default: null
    },
    queryEndDate: {
      type: String,
      required: false,
      default: null
    },
    isAutoRefresh: {
      type: Boolean,
      required: true
    },
    isReset: {
      type: Boolean,
      required: false
    },
    rawStateId: {
      type: Number,
      required: true
    },
    virtualDeviceId: {
      type: Number,
      required: true
    },
    bridgeManifest: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      packetHistory: [],
      dataIsLoading: false,
      loadingDone: false,
      loadingError: null,
      offset: 0,
      serverItemsLength: -1,
      update: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions', 'language']),
    hasNoPackets() {
      return !this.dataIsLoading && this.packetHistory.length === 0 && this.loadingDone;
    },
    colNumber() {
      return 5 + (get(this.bridgeManifest, 'virtualDevice.deviceTypes.packetParser.valueMapping.port') ? 1 : 0) + (this.bridgeManifest.virtualDevice.metaData || []).length;
    },
    isLiveViewer() {
      // NOTE: isLiveViewer is a prop handed over to `packet-parser`, whilst referencing the same component
      // so to bypass this kinda "race-condition", include `loadingDone` which is set with a delay,
      // to force to re-eval this computed prop, when the `packet-viewer`-ref evaluated correctly
      if (this.$refs['packet-viewer']) {
        return false;
      }
      return this.isAutoRefresh && this.loadingDone && !this.$refs['packet-viewer'].scrolledDown;
    }
  },
  watch: {
    queryItemsInflux: debounce(function () {
      if (this.isAutoRefresh) {
        // only auto-refresh if the user is scrolled all the way up to the top
        // otherwise do not destroy the current state/entry the user might be looking at!
        const el = this.$refs['packet-viewer'].$refs['top-element'];
        if (!el) {
          return;
        }
        const holder = this.$refs['packet-viewer'].$refs['outer-container'];
        const {
          top,
          bottom,
          height
        } = el.getBoundingClientRect();
        const holderRect = holder.getBoundingClientRect();
        const isVisible = top <= holderRect.top ? holderRect.top - top <= height : bottom - holderRect.bottom <= height;
        if (!isVisible && !this.isReset) {
          // do not auto-refresh if the title is not visible, i.e. the content is scrolled
          return;
        }
      }
      this.isReset = false;
      this.offset = 0;
      this.loadData(false, true);
    }, 500, {
      leading: true
    })
  },
  mounted() {
    this.loadData();
  },
  methods: {
    clickRowHandler(item) {
      this.$emit('click', item);
    },
    get,
    loadData(increaseOffset, reset = false) {
      if (this.dataIsLoading) {
        return;
      }
      this.loadingError = null;
      this.dataIsLoading = true;
      if (increaseOffset) {
        this.offset += 1;
      }
      const usedPage = this.offset;
      const usedItemsPerPage = 50;
      const sortDirection = 'DESC';
      this.loadDetailledHistoryData(this.rawStateId, this.virtualDeviceId, 'time', sortDirection, usedPage, usedItemsPerPage).then(res => {
        this.serverItemsLength = res.totalCount;
        if (reset) {
          this.packetHistory = [];
        }
        this.packetHistory.push(...res.items);
        if (this.packetHistory.length > 0) {
          this.$emit('click', this.packetHistory[0]);
        }
        return this.packetHistory;
      }).catch(err => {
        if (err.code === 'ECONNABORTED') {
          this.loadingError = 'TIMEOUT';
        } else {
          this.loadingError = 'UKNOWN';
        }
      }).finally(() => {
        this.dataIsLoading = false;
        this.loadingDone = true;
      });
    }
  }
};